import { createAction } from '@reduxjs/toolkit';
import { CALC_ENGINE_ACTION_PREFIX } from '../utilities/constants';

/**
 * Warning!  If you dispatch this action your workflow better re-load and transform ALL structured documents
 * aka 'clearDataAndtransformAllIngestedStructuredDocumentsThunk'
 */
export default createAction(
  `${CALC_ENGINE_ACTION_PREFIX}/resetCalculationDataForDocument`,
  function prepare(documentCode) {
    return {
      payload: { documentCode },
    };
  }
);
